export default function InputHidden({ name, type, value }) {
    return <input type={type} name={name} value={value} />
}
